import type { IEnvironment } from 'relay-runtime';

import { disposableValue } from '../../utils/disposable-value';

import type { SearchPageState } from './types';

/**
 * Holds the preloaded search page state along with environment and feature flags.
 * This is used for providing initial state to the search page from preloading.
 **/
export const PRELOAD_SEARCH_PAGE_STATE = disposableValue<
	SearchPageState & {
		environment: IEnvironment;
		isAdminHubAIEnabled: boolean;
		isRovoLLMEnabled: boolean;
	}
>();
